import React from 'react';
import './LocationMapModal.css';

export default function LocationMapModal({ isOpen, onClose, address, apiKey }) {
    if (!isOpen || !address) return null;

    const encodedAddress = encodeURIComponent(address);
    // Using Google Maps Embed API in View Mode
    // mode=place requires a 'q' parameter
    const mapUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodedAddress}`;

    return (
        <div className="map-modal-overlay" onClick={onClose}>
            <div className="map-modal-content" onClick={e => e.stopPropagation()}>
                <div className="map-modal-header">
                    <h3>Location Map</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="map-frame-container">
                    <iframe
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        src={mapUrl}
                        title="Event Location Map"
                    ></iframe>
                </div>
                <div className="map-modal-footer">
                    <p className="address-display">📍 {address}</p>
                </div>
            </div>
        </div>
    );
}
